class ArrayUtils {
  static sum(array: number[]): number {
    return array.reduce((a, b) => a + b, 0);
  }

  static mean(array: number[]): number {
    return ArrayUtils.sum(array) / array.length;
  }

  static isDefined(array: Array<number | undefined>): boolean {
    return array.filter((value) => value !== undefined).length > 0;
  }
}

export default ArrayUtils;
